import { SlotProps } from './slot.types';

/**
 * This is a component that is meant to be used with complex layout composition
 * The generic type T is to allow locking in the supported slots for a given component
 *
 * Content can be provided via `children` or the `render` prop; `children` takes
 * precedence when both are supplied.
 */
export const Slot = (props: Readonly<SlotProps>) => props.children ?? props.render;
